import CheckIcon from 'assets/icons/check-circle-success.svg'
import axios from 'axios'
import PMBTotalFooter from 'components/PMBTotalFooter'
import { uploadFile } from 'features/private-views/sell-commodity/sellCommodityAction'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { AlertCircle, X } from 'react-feather'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, CardBody, CardTitle, Container, Form } from 'reactstrap'
import {
  newFormatThousandSeparator,
  parseNumberFromString,
} from 'utils/formatNumber'
import { URL_CONFIRM_PIN_TRANSAKSI } from 'utils/pathUrl'
import { apiEndpoint } from '../../../utility/Utils'
import { setTotal } from '../commodityPurchaseSlice'
import ModalReceive from '../confirmPayment/ModalReceive'

const ConfirmCashPayment = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const intl = useIntl()
  const { enqueueSnackbar } = useSnackbar()
  const location = useLocation()
  const dataState = location.state

  const { token } = useSelector((e) => e.auth)
  const { total } = useSelector((s) => s.comodityPurchase)

  const [userData, setUserData] = useState({})
  const [dataProfile, setDataProfile] = useState({})
  const [isOpenModalReceive, setIsOpenModalReceive] = useState(false)
  const [fileNames, setFileNames] = useState([])
  const [files, setFiles] = useState([])
  const [errMsg, setErrMsg] = useState('')
  const toggleModalReceive = () => {
    setIsOpenModalReceive(!isOpenModalReceive)
  }

  const handleSubmit = () => {
    const updatedUserData = {
      ...userData,
      proofOfPayment: files?.map((e) => e?.fileUrl),
      useProofOfPayment: true,
    }
    setUserData(updatedUserData)

    navigate(URL_CONFIRM_PIN_TRANSAKSI, {
      state: {
        dataProfile: dataProfile,
        userData: updatedUserData,
        dataState: dataState,
        isCash: true,
      },
    })
  }

  const getProfile = async () => {
    try {
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/profile`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      setDataProfile(data)
    } catch {
      // Error fetching profile
      console.warn('Error fetching profile')
    }
  }

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'))
    setUserData(userData)
    getProfile()
    dispatch(setTotal(dataState?.totalAmount))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const totalNewAmount = dataState?.item?.reduce(
    (sum, e) =>
      sum + parseNumberFromString(e?.price) * parseNumberFromString(e?.amount),
    0,
  )

  return (
    <div className="w-100 mt-3">
      <ModalReceive
        toggle={toggleModalReceive}
        isOpen={isOpenModalReceive}
        handleSubmit={handleSubmit}
        testId="confirm-cash-receive-modal"
      />
      <Container fluid className="custom-container pb-5 mb-5">
        <p className="fw-600 py-2">Pembayaran tunai atau sudah bayar</p>

        <Card className="p-2">
          <CardBody>
            <div className="mb-5">
              <div className="mb-3 d-flex justify-content-between">
                <span className="fw-bold">Daftar Pembelian</span>
                <>
                  {' '}
                  {userData?.alreadyReceived ? (
                    <div className="text-success-700 rounded bg-success-50 p-1">
                      {' '}
                      <small className="fw-500 mx-1">
                        <img src={CheckIcon} alt="check-icon" /> Barang sudah
                        diterima
                      </small>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              </div>
              {dataState?.item?.map((e, index) => {
                return (
                  <div
                    key={index}
                    className="d-flex flex-row gap-3 align-items-center mb-3"
                  >
                    <img
                      src={e?.comodity?.img ?? e?.comodity?.linkFoto}
                      className="rounded float-left"
                      style={{ width: '60px', height: '60px' }}
                      alt="barang"
                    />
                    <div className="d-flex flex-column">
                      <span>
                        {e?.comodity?.label} {e?.amount} {e?.unit}
                      </span>
                      <span style={{ fontWeight: 'bold' }}>
                        Rp
                        {newFormatThousandSeparator(
                          parseNumberFromString(e?.price) *
                            parseNumberFromString(e?.amount),
                        )}
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="">
              <div className="d-flex justify-content-between">
                <span style={{ fontWeight: 'bold' }}>Total Transaksi</span>
                <span style={{ fontWeight: 'bold' }}>
                  Rp
                  {newFormatThousandSeparator(totalNewAmount)}
                </span>
              </div>
            </div>
          </CardBody>
        </Card>
        <Card className="mt-4">
          <CardBody>
            <CardTitle style={{ fontWeight: 'bold' }} tag="h6" className="mb-2">
              Bukti pembayaran
            </CardTitle>
            <small>
              Upload bukti pembayaran berupa foto kwitansi atau screenshot
              transfer
            </small>
            <Form
              encType="multipart/form-data"
              className="flex-centered border rounded"
              style={{ overflow: 'hidden' }}
            >
              <fieldset className="fieldset">
                <input
                  className="input-file"
                  id="transactions"
                  name="transactions"
                  data-testid="confirm-cash-upload-input"
                  onChange={async (e) => {
                    setErrMsg('')
                    const newFiles = e.target.files
                    if (newFiles.length > 3) {
                      enqueueSnackbar('Maksimal 3 file yang dapat diunggah', {
                        variant: 'error',
                      })
                      return
                    }

                    let newFileNames = []
                    let newUploadedFiles = []

                    for (let i = 0; i < newFiles.length; i++) {
                      const uploadedFile = await dispatch(
                        uploadFile(newFiles[i]),
                      )

                      if (uploadedFile.error) {
                        enqueueSnackbar(
                          uploadedFile?.payload || 'Upload gagal',
                          {
                            variant: 'error',
                          },
                        )
                      } else {
                        const fileId = Date.now() + i
                        newFileNames.push({
                          id: fileId,
                          fileName: newFiles[i].name,
                        })
                        newUploadedFiles.push({
                          id: fileId,
                          fileUrl: uploadedFile?.payload?.url,
                        })
                      }
                    }

                    setFileNames((prev) => [...prev, ...newFileNames])
                    setFiles((prev) => [...prev, ...newUploadedFiles])
                  }}
                  type="file"
                  accept=".png, .jpeg, .jpg, .pdf"
                  multiple
                />
                <label htmlFor="transactions" className="d-flex">
                  Upload
                </label>
              </fieldset>
              <div className="w-100" style={{ padding: '10px 14px' }}>
                {fileNames?.length > 0
                  ? fileNames?.map((e, i) => (
                      <span className="ms-3 badge-line" key={i} data-testid={`confirm-cash-upload-file-${e.id}`}>
                        {e.fileName}
                        <X
                          size={16}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setErrMsg('')
                            const filteredFileNames = fileNames.filter(
                              (file) => file.id !== e.id,
                            )
                            const filteredFiles = files.filter(
                              (file) => file.id !== e.id,
                            )
                            setFileNames(filteredFileNames)
                            setFiles(filteredFiles)
                          }}
                        />
                      </span>
                    ))
                  : 'Belum ada file'}
              </div>
            </Form>
            {errMsg && (
              <small className="text-danger" data-testid="confirm-cash-error-message">
                <AlertCircle size={15} /> {errMsg}
              </small>
            )}
          </CardBody>
        </Card>
      </Container>
      <PMBTotalFooter
        total={total}
        isDisable={files?.length < 1}
        onSubmit={handleSubmit}
        textBtn="Selesaikan Transaksi"
        testId="confirm-cash"
      />
    </div>
  )
}

export default ConfirmCashPayment
